import { TableBody as MUITableBody, TableBodyProps } from '@mui/material';

export { type TableBodyProps } from '@mui/material';

export function TableBody(props: TableBodyProps) {
  return <MUITableBody {...props} />;
}
